import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import About from './views/About.vue';
import Login from './views/Login.vue';
import Policy from './views/Policy.vue';
import UserData from './views/UserData.vue';
import Transfer from './views/Transfer.vue';
import Error from './views/Error.vue';
import HowItWorks from './views/HowItWorks.vue';
import VueAnalytics from 'vue-analytics';
import Download from './views/Download.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/about',
      name: 'about',
      component: About,
    },
    {
      path: '/how-it-works',
      name: 'how-it-works',
      component: HowItWorks,
    },
    {
      path: '/transfer/:id',
      name: 'transfer',
      component: Transfer,
    },
    {
      path: '/privacy_policy.html',
      name: 'policy',
      component: Policy,
    },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    // },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/user-data',
      name: 'user-data',
      component: UserData,
    },
    {
      path: '/download',
      name: 'download',
      component: Download,
    },
    {
      path: '/error',
      name: 'error',
      component: Error,
    },
    {
      path: '*',
      name: 'defailt-error',
      component: Error,
    },
  ],
});

Vue.use(VueAnalytics, {
  id: 'UA-140782843-1',
  router,
  autoTracking: {
    pageviewTemplate(route: any) {
      return {
        page: route.path,
        title: document.title,
        location: window.location.href,
      };
    },
  },
});

export default router;
